import React, { Component } from "react";
import Icons from "./components/Icons";
import Hero from "./components/Hero";
import Learners from "./components/Learners";
import CoursesView from "./components/CoursesView";
import SpiritTeacherQuiz from "./components/SpiritTeacherQuiz";
import { CurrentUserResource } from "../../stores/CurrentUserStore/Types";
// import currentUser from "../../containers/DefaultNavbar/CurrentUser";

interface Props {
  match: any;
  currentUser: CurrentUserResource;
}

interface State {
  loading: boolean;
  quizOpen: boolean;
}

class AllCourses extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      quizOpen: false,
    };
  }

  componentDidMount() {}

  openQuiz = () => {
    this.setState({ quizOpen: true });
  };

  closeQuiz = () => {
    this.setState({ quizOpen: false });
  };

  render() {
    const { currentUser } = this.props;

    return (
      <>
        <Icons />
        <a href="#main" className="skip-link sr-only">
          Skip to main content
        </a>
        <main className="facelift-landing-page facelift-courses" id="main">
          <Hero onOpenQuiz={this.openQuiz} />
          <CoursesView userIsInUk={currentUser.is_in_uk} />
          <section className="trust" aria-label="Trusted by">
            <div className="container">
              <div className="trust-label">Trusted by learners at</div>
              <div className="trust-logos">
                <span>Google</span>
                <span>Kroger</span>
                <span>Forbes</span>
                <span>Facebook</span>
                <span>Amazon</span>
                <span>IDEO</span>
              </div>
            </div>
          </section>
          <section className="still" aria-labelledby="still-title">
            <div className="container">
              <h2 id="still-title">
                Still <em>not sure</em>?
              </h2>
              <p>
                Take a course on us. About four minutes in, you'll know whether
                42courses is for you. If you've got a team to upskill, our team
                plans page has more on what's included.
              </p>
              <div className="btn-row">
                <a href="/courses#sample-courses" className="btn btn-primary">
                  Try a course on us →
                </a>
                <a href="/team_plans" className="btn btn-secondary">
                  For teams &amp; companies
                </a>
              </div>
            </div>
          </section>
          <div className="container">
            <p className="catalogue-note">
              42courses offers 40+ CPD-accredited Mini MBAs across behavioural
              science, marketing, AI and leadership. Each one is co-created with
              working practitioners, the likes of Rory Sutherland, Dan Ariely
              and Sir John Hegarty, plus some sixty others who wrote the book on
              these subjects, literally.
            </p>
          </div>
        </main>
        <SpiritTeacherQuiz
          isOpen={this.state.quizOpen}
          onOpen={this.openQuiz}
          onClose={this.closeQuiz}
        />
      </>
    );
  }
}

export default AllCourses;
